export const commandShortcuts: Record<string, string[]> = {
  // Formatação
  heading1: ["Mod", "1"],
  bulletList: ["Mod", "Shift", "l"],
  numberedList: ["Mod", "Shift", "o"],
  taskList: ["Mod", "Alt", "t"],
  blockquote: ["Mod", "Alt", "q"],

  // Inserir elementos
  stepper: ["Mod", "Shift", "s"],
  table: ["Mod", "Shift", "b"],
  image: ["Mod", "Shift", "i"],
  chart: ["Mod", "Shift", "g"],
  columns: ["Mod", "Shift", "c"],
  highlightBlock: ["Mod", "Shift", "h"],
  horizontalRule: ["Mod", "Shift", "r"],

  // Comandos
  openCommands: ["Mod", "k"],
};

export const getShortcutDisplay = (shortcut: string[]): string => {
  if (!shortcut || shortcut.length === 0) return "";

  return shortcut
    .map((key) => {
      if (key === "Mod") {
        return navigator.platform.includes("Mac") ? "⌘" : "Ctrl";
      }
      if (key === "Shift") {
        return "⇧";
      }
      if (key === "Alt") {
        return navigator.platform.includes("Mac") ? "⌥" : "Alt";
      }
      return key.toUpperCase();
    })
    .join("");
};
